import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {AiOutlineBank} from 'react-icons/ai'
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";


export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Invoice Items')}
            icon={<AiOutlineBank/>}
            tools={[<ReloadRecordsButton key='reload'/>]}
        />
    );
};
